export { THEME_KEY, DEFAULT_SCHEME, SCHEME_NAMES } from './theme.js';
export { FLAG_MAP } from './flag.js';
export {
  ACTION_TYPE,
  DEFAULT_ACTION_TYPES,
  scanCategories,
  dialogCategories,
  customCategories,
  scanNameKeys,
  systemLinkCategories,
  systemLinkEndNameKeys,
  systemLinkNameKeys,
  systemLinkRoutes,
  parseActionValue,
  buildActionValue,
  getActionNameKey,
  getSystemLinkRoute,
  executeAction,
  buildNavigateLinkValue,
} from './systemLinks.js';
export { TEMPLATE_TYPE, TEMPLATE_TYPE_MAP, TEMPLATE_TYPE_OPTIONS } from './templateType.js';
export { default as countries } from './countries.js';

/**
 * HTTP 状态码
 * @type {{ OK: 200, UNAUTHORIZED: 401, FORBIDDEN: 403, NOT_FOUND: 404, SERVER_ERROR: 500 }}
 */
export const HTTP_STATUS = {
  OK: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

/**
 * 业务状态码
 * @type {{ LOGOUT: number[] }}
 */
export const BUSINESS_CODE = {
  LOGOUT: [10001, 10013],
  SUCCESS: [0],
};

/**
 * 本地存储 Key（通用，无项目前缀）
 * @type {{ TOKEN: string, BRAND_NO: string, LOCALE: string, USER_INFO: string, REMEMBER_ME: string, REQUEST_SN: string, CODE_VALUE: string }}
 */
export const STORAGE_KEYS = {
  TOKEN: 'zy_token',
  BRAND_NO: 'zy_brand_no',
  LOCALE: 'zy_locale',
  USER_INFO: 'zy_user_info',
  REMEMBER_ME: 'zy_remember_me',
  REQUEST_SN: 'zy_request_sn',
  CODE_VALUE: 'zy_code_value',
  QRCODE_DATA: 'zy_qrcode_data',
};

/**
 * 品牌后台专用存储 Key（避免与 zht-admin 共享 localStorage 冲突）
 */
export const BRAND_STORAGE_KEYS = {
  TOKEN: 'ba_token',
  BRAND_NO: 'ba_brand_no',
  LOCALE: 'zy_locale',
  USER_INFO: 'ba_user_info',
  REMEMBER_ME: 'ba_remember_me',
};

/**
 * 平台管理后台专用存储 Key
 */
export const ZHT_STORAGE_KEYS = {
  TOKEN: 'zht_token',
  BRAND_NO: 'zht_brand_no',
  LOCALE: 'zy_locale',
  USER_INFO: 'zht_user_info',
  REMEMBER_ME: 'zht_remember_me',
};

/**
 * 营销后台专用存储 Key
 */
export const MKT_STORAGE_KEYS = {
  TOKEN: 'mkt_token',
  BRAND_NO: 'mkt_brand_no',
  LOCALE: 'zy_locale',
  USER_INFO: 'mkt_user_info',
  REMEMBER_ME: 'mkt_remember_me',
};

/**
 * 默认分页参数
 * @type {{ page: number, page_size: number }}
 */
export const DEFAULT_PAGINATION = {
  page: 1,
  page_size: 20,
};

/**
 * 支持的语言（全量目录，静态兜底）
 *
 * 所有项目默认支持的语言全集。
 * 接口（/admin/common/languages 或 /h5/langList）提供"当前启用的子集"，
 * locale store 在接口可用时用接口数据，不可用时降级回此常量。
 *
 * 新增/下线语言：
 * 1. 在此处新增条目
 * 2. 各端 locales/lang/ 下新增对应词条文件
 * 3. 后端语言管理界面启用/停用
 *
 * @type {Array<{ code: string, label: string }>}
 */
export const SUPPORTED_LOCALES = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en-US', label: 'English' },
  { code: 'ja', label: 'Japanese' },
];

/**
 * 默认语言（最终兜底）
 *
 * 优先级链：
 *   登录接口 data.lang → 语言列表接口 is_default → 列表首项 → 此常量
 *
 * @type {string}
 */
export const DEFAULT_LOCALE = 'zh-CN';
